import RokuePreview from "./RokuPreview";

interface IProps {
  productParams: any;
  setClickedCatFbsCb: any;
  ClickedCatFbsVal: any;
  setClickedCat: any;
  ClickedCat: any;
  technology: any;
  generalPreviewRef: any;
  feedbackPreviewRef: any;
  widgetCodePreviewRef: any;
  qrCodePreviewRef: any;
}

const Roku = ({
  productParams,
  setClickedCatFbsCb,
  ClickedCatFbsVal,
  setClickedCat,
  ClickedCat,
  technology,
  generalPreviewRef,
  feedbackPreviewRef,
  widgetCodePreviewRef,
  qrCodePreviewRef,
}: IProps) => {
  const addQR =
    productParams?.productParams?.products?.[0]?.feedbackAgentSettings
      ?.qrSettings?.addQR;

  return (
    <>
      <RokuePreview
        page={1}
        productParams={productParams}
        setClickedCatFbsCb={setClickedCatFbsCb}
        ClickedCatFbsVal={ClickedCatFbsVal}
        setClickedCat={setClickedCat}
        ClickedCat={ClickedCat}
        technology={technology}
        generalPreviewRef={generalPreviewRef}
        feedbackPreviewRef={feedbackPreviewRef}
        widgetCodePreviewRef={widgetCodePreviewRef}
        qrCodePreviewRef={qrCodePreviewRef}
      />
      <RokuePreview
        page={2}
        productParams={productParams}
        setClickedCatFbsCb={setClickedCatFbsCb}
        ClickedCatFbsVal={ClickedCatFbsVal}
        setClickedCat={setClickedCat}
        ClickedCat={ClickedCat}
        technology={technology}
        generalPreviewRef={generalPreviewRef}
        feedbackPreviewRef={feedbackPreviewRef}
        widgetCodePreviewRef={widgetCodePreviewRef}
        qrCodePreviewRef={qrCodePreviewRef}
      />
      <RokuePreview
        page={3}
        productParams={productParams}
        setClickedCatFbsCb={setClickedCatFbsCb}
        ClickedCatFbsVal={ClickedCatFbsVal}
        setClickedCat={setClickedCat}
        ClickedCat={ClickedCat}
        technology={technology}
        generalPreviewRef={generalPreviewRef}
        feedbackPreviewRef={feedbackPreviewRef}
        widgetCodePreviewRef={widgetCodePreviewRef}
        qrCodePreviewRef={qrCodePreviewRef}
      />

      {addQR && (
        <RokuePreview
          page={4}
          productParams={productParams}
          setClickedCatFbsCb={setClickedCatFbsCb}
          ClickedCatFbsVal={ClickedCatFbsVal}
          setClickedCat={setClickedCat}
          ClickedCat={ClickedCat}
          technology={technology}
          generalPreviewRef={generalPreviewRef}
          feedbackPreviewRef={feedbackPreviewRef}
          widgetCodePreviewRef={widgetCodePreviewRef}
          qrCodePreviewRef={qrCodePreviewRef}
        />
      )}
      {!addQR && (
        <RokuePreview
          page={addQR ? 5 : 4}
          productParams={productParams}
          setClickedCatFbsCb={setClickedCatFbsCb}
          ClickedCatFbsVal={ClickedCatFbsVal}
          setClickedCat={setClickedCat}
          ClickedCat={ClickedCat}
          technology={technology}
          generalPreviewRef={generalPreviewRef}
          feedbackPreviewRef={feedbackPreviewRef}
          widgetCodePreviewRef={widgetCodePreviewRef}
          qrCodePreviewRef={qrCodePreviewRef}
        />
      )}
    </>
  );
};

export default Roku;
